var app = angular.module('leonardo');

var WidgetPriority = function(TemplateService) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    templateUrl: 'views/templates/widget/priority.html',
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      label: '@',
      inline: '@'
    },
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.data = {
        value: null,
        options: angular.copy(TemplateService.PRIORITY_OPTIONS)
      };

      scope.toggle = function(value) {
        scope.ngModelCtrl.$setViewValue(value);
      };

      scope.ngModelCtrl.$render = function() {
        scope.data.value = scope.ngModelCtrl.$modelValue;
      };
    }
  };
};

app.directive('widgetPriority', ['TemplateService', WidgetPriority]);
